<template>
  <div class="login-container">
    <!-- 左侧品牌展示区 -->
    <div class="login-brand">
      <div class="login-brand__bg"></div>
      <div class="login-brand__content">
        <div class="login-brand__logo">
          <h1 class="login-brand__title">
            <i class="fas fa-cloud-upload-alt login-brand__icon"></i>
          </h1>
        </div>
        <div class="login-brand__hero">
          <h2 class="login-brand__heading">
            绿鹊回收 运营管理端
          </h2>
          <p class="login-brand__desc">
            互联网 + 旧衣回收服务平台，助力企业数字化转型
          </p>
          <div class="login-brand__image-wrapper">
            <img
                :src="'https://ai-public.mastergo.com/ai/img_res/5c8fa1ce137b575952a3b626d21403c1.jpg'"
                class="login-brand__image"
                alt="Platform Illustration"
            />
          </div>
        </div>
        <div class="login-brand__copyright">
<!--          Copyright © 2026 绿鹊回收旧衣回收 All Rights Reserved.-->
          冀ICP备2026011490号-1
        </div>
      </div>
    </div>
    <!-- 右侧登录区域 -->
    <div class="login-form">
      <div class="hs-login-box">
        <div style="text-align: center; font-size: 22px;font-weight: 500; color: black">账号登陆</div>
        <div class="hs-login-form">
          <div class="hs-login-row">
            <div class="hs-login-label">用户名：</div>
            <div class="hs-login-value">
              <Input type="text" v-model.tirm="formInline.username" @keyup.enter.native="handleSubmit"
                     placeholder="请输入登录账号"></Input>
            </div>
          </div>
          <div class="hs-login-row">
            <div class="hs-login-label">密码：</div>
            <div class="hs-login-value">
              <Input type="password" v-model.tirm="formInline.password" @keyup.enter.native="handleSubmit"
                     placeholder="请输入密码"></Input>
            </div>
          </div>
          <div class="hs-login-row">
            <template v-if="isPc">
              <hs-verification-pc @change="verificationChange"></hs-verification-pc>
            </template>
            <template v-else>
              <hs-verification-app @change="verificationChange"></hs-verification-app>
            </template>
          </div>
        </div>
        <Button type="primary" size="large" :style="{width:'100%'}" @click="handleSubmit" :loading="btnLoading">登录
        </Button>
      </div>
    </div>
  </div>
</template>
<script>
import hsVerificationPc from '@/components/hs-verification-pc';
import hsVerificationApp from '@/components/hs-verification-app';

export default {
  name: "login",
  data() {
    return {
      btnLoading: false,
      formInline: {
        username: '',
        password: '',
        verification: false
      },
      isPc: true,
    }
  },
  mounted() {
    // 判断是手机端还是PC端
    this.judge();
  },
  methods: {
    // 验证登录信息
    handleSubmit() {
      // 判断用户名
      if (!this.formInline.username) {
        this.$Message.error('请输入用户名');
        return false;
      } else if (!/^[0-9a-zA-Z]+$/.test(this.formInline.username)) {
        this.$Message.error('用户名格式不正确');
        return false;
      } else if (!this.formInline.password) {
        this.$Message.error('请输入密码');
        return false;
      } else if (!this.formInline.verification) {
        this.$Message.error('请滑动验证码');
        return false;
      } else {
        // 登录
        this.loginCheck();
      }
    },
    // 登录后台
    loginCheck() {
      this.btnLoading = true;
      this.axios.post('/adminLogin/loginCheck', this.formInline).then(res => {
        this.btnLoading = false;
        if (res.status == 200) {
          // 保存登录凭证到sessionStorage
          sessionStorage.setItem('J-TOKEN', JSON.stringify(res.data));
          // 跳转统计页面
          this.$router.push({
            path: '/index/charts',
            query: {tenantId: res.data.admin.tenantId}
          })
        }
        if (res.status == 201) {
          this.$Message.error(res.msg);
        }
      })
    },
    // 判断是手机端还是PC端打开
    judge() {
      if (/Android|webOS|iPhone|iPod|BlackBerry/i.test(navigator.userAgent)) {
        this.isPc = false;
      } else {
        this.isPc = true;
      }
      window.addEventListener('resize', () => {
        console.log('窗口变化了')
        if (/Android|webOS|iPhone|iPod|BlackBerry/i.test(navigator.userAgent)) {
          this.isPc = false;
        } else {
          this.isPc = true;
        }
      })
    },
    // 滑动验证
    verificationChange(e) {
      console.log(e)
      this.formInline.verification = e;
    }
  },
  components: {
    hsVerificationPc,
    hsVerificationApp
  }
}

</script>
<style scoped>
.login-container {
  height: 100vh;
  display: flex;
  background: url("../assets/logbg.png") no-repeat center top;
  background-size: 100% 100%;
}
.login-brand {
  width: 45%;
  position: relative;
  overflow: hidden;
}
.login-brand__bg {
  position: absolute;
  inset: 0;
}
.login-brand__content {
  position: relative;
  z-index: 10;
  padding: 3rem;
  height: 100%;
  display: flex;
  flex-direction: column;
}
.login-brand__logo {
  height: 40px;
  margin-bottom: 2rem;
}
.login-brand__title {
  font-size: 1.5rem;
  font-weight: 700;
  color: rgb(31, 41, 55);
  display: flex;
  align-items: center;
}
.login-brand__icon {
  color: rgb(37, 99, 235);
  margin-right: 0.75rem;
}
.login-brand__hero {
  flex-grow: 1;
  display: flex;
  margin-left: 50px;
  flex-direction: column;
  justify-content: center;
}
.login-brand__heading {
  font-size: 2rem;
  font-weight: 700;
  color: rgb(31, 41, 55);
  margin-bottom: 1rem;
}
.login-brand__desc {
  font-size: 1.25rem;
  color: rgb(75, 85, 99);
  margin-bottom: 2rem;
}
.login-brand__image-wrapper {
  position: relative;
  width: 100%;
  height: 18rem;
}
.login-brand__image {
  width: 100%;
  height: 100%;
  object-fit: contain;
}
.login-brand__copyright {
  text-align: center;
  font-size: 0.875rem;
  color: rgb(107, 114, 128);
  margin-top: 2rem;
}
.login-form {
  width: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
}
.hs-login-box {
  width: 350px;
  padding: 30px 25px;
  background-color: #ffffff;
  box-shadow: 1px 3px 9px -4px #888888;

  .hs-login-form {
    .hs-login-row {
      margin-bottom: 20px;

      .hs-login-label {
        color: #515a6e;
        font-size: 14px;
      }

      .hs-login-value {
        input {
          width: 100%;
          height: 35px;
        }
      }
    }
  }
}
</style>
